var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{directives:[{name:"perms",rawName:"v-perms",value:(['multi_user']),expression:"['multi_user']"}],staticClass:"btn btn-ss-standout",attrs:{"type":"button"},on:{"click":function($event){return _vm.$modal.show(`add-user-modal`)}}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',[_c('i',{staticClass:"la la-plus-circle"}),_vm._v(" "),_c('span',[_vm._v("User")])])
}]

export { render, staticRenderFns }